module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("ABROGATE")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("E")]), _vm._v("xcuses are like raindrops in a cloudburst as they can fall so fast that a flash flood can fabricate And some excuses are truly real that have no appeal but to resolve because there is no excuse not to follow the Master’s plan of salvation; for to do so, heaven you do abrogate.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The natural man has excuses for every trap and sin that Satan has set for us to be ensnared")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And in evil’s mesh spun so very cleverly that you never feel the filthy knife that from the Tree of Knowledge you are pared.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("A truly righteous soul mandates honor and accountability from themselves as well as from those they know")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To ensure that the light of Christ’s pure love surrounds them in a brightness that makes the wicked cower and hide their faces from the brilliance of its glow.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("On judgment day, every excuse known to man will be expounded to no avail")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For your works, deeds, and testimony are the only keys that will escort you through the veil.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("An excuse is just a way of saying that you are not willing to find another way to accomplish the task that is the goal")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For it is a person rare that the task will be accomplished, no matter what the cost,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("for they know that their soul is on the line and have the courage to pay the toll.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Excuses are like raindrops in a cloudburst as they can fall so fast that a flash flood of lies, they can fabricate")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And some excuses are truly real that have no appeal but to resolve because there is no excuse not to follow the master’s plan of salvation; for to do so, heaven you do abrogate.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70801cdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap001.vue
// module id = 69
// module chunks = 0